import React from 'react';
import { TelegramUtils } from './telegram';

/**
 * Component that converts URLs in text to clickable links
 */
export const Linkify: React.FC<{ children: string }> = ({ children }) => {
  // URL regex pattern
  const urlPattern = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s]*)/gi;
  
  const parts = children.split(urlPattern);
  
  return (
    <>
      {parts.map((part, index) => {
        // Check if part matches URL pattern
        if (part.match(urlPattern)) {
          let href = part;
          // Add https:// if no protocol specified
          if (!href.match(/^https?:\/\//i)) {
            href = `https://${href}`;
          }
          
          return (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white underline hover:text-white/80 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                TelegramUtils.haptic.light();
              }}
            >
              {part}
            </a>
          );
        }
        return <React.Fragment key={index}>{part}</React.Fragment>;
      })}
    </>
  );
};

